import axios from "axios";

const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append('quality', 5);
  formData.append(
    "upload_preset",
    process.env.REACT_APP_CLOUDINARY_UNSIGNED_PRESET
  );
  try {
    const response = await axios.post(
      process.env.REACT_APP_CLOUDINARY_UNSIGNED_URL,
      formData
    );
    return response.data;
  } catch (error) {
    throw new Error(error)
  }
};

export default uploadFile;
